export const RECORDABLE_COMMAND_IDS = [
  "delete-backward", "delete-forward", "move-left", "move-right", "move-up", "move-down",
  "select-left", "select-right", "line-start", "line-end", "doc-start", "doc-end",
  "indent-more", "indent-less", "insert-line", "delete-line", "duplicate-line", "move-line-up", "move-line-down", "join-lines",
  "toggle-line-comment", "toggle-case", "expand-selection", "shrink-selection"
] as const;

export type RecordableCommandId = typeof RECORDABLE_COMMAND_IDS[number];
export type SearchAction = "find-next" | "find-previous" | "replace-next" | "replace-all";

export interface SearchSpec {
  query: string;
  replacement: string;
  caseSensitive: boolean;
  wholeWord: boolean;
  regexp: boolean;
}

export type MacroStepV1 =
  | { kind: "insert"; text: string }
  | { kind: "command"; command: RecordableCommandId }
  | { kind: "search"; action: SearchAction; query: SearchSpec };

export interface StoredMacroV1 {
  schemaVersion: 1;
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  steps: MacroStepV1[];
}

export interface MacroBundleV1 {
  schemaVersion: 1;
  exportedAt: string;
  macros: StoredMacroV1[];
}

export type PlaybackMode =
  | { kind: "once" }
  | { kind: "count"; iterations: number }
  | { kind: "until-eof" };

export type LanguageId = "text" | "markdown" | "json" | "javascript" | "typescript" | "python" | "go" | "html" | "css" | "yaml" | "sql";
export type ThemePreference = "system" | "light" | "dark";
export type KeymapProfile = "standard" | "jetbrains";

export interface RecoveryDraft {
  id: "current";
  text: string;
  filename: string;
  language: LanguageId;
  lineEnding: "LF" | "CRLF";
  hadBom: boolean;
  updatedAt: string;
}
